import React, { useEffect, useState } from 'react';
import DoctorWrapper from '../TeacherWrapper';
import { useParams } from 'react-router-dom';

const DoctorCourcesDetails = () => {
  const [tab, setTabs] = useState('details');
  const { id } = useParams();
  const [courseData, setCourseData] = useState();
  const [enrolled, setEnrolled] = useState('');
  const [myCourse, setMyCourse] = useState('');
  const [totalStudents, setTotalStudents] = useState([]);

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${id}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data);
        setCourseData(data?.course);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/user/all-students-course/${id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data?.data.length);
        setEnrolled(data?.data.length);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetchStudentList();
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-course/${data?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data.length);
        setMyCourse(data.length);
      })
      .catch((error) => console.error(error));
  }, []);

  const fetchStudentList = () => {
    // console.log("HELLEO");

    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      teacherId: data?._id,
      courseId: id
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(
      'https://quran-backend-theta.vercel.app/v1/teacher/teacher-students-course',
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        
        let data = JSON.parse(result);
        // console.log("DATA", data?.data);
        setTotalStudents(data?.data);
      })
      .catch((error) => console.error(error));
  };

  return (
    <DoctorWrapper>
      <h2 className="main_title ">{courseData?.name}</h2>
      <p className=" text-[#1C1D1D]">Here are details of your courses</p>

      <div>
        <ul className=" mt-6 flex w-full gap-4 border-b">
          <li className=" cursor-pointer" onClick={() => setTabs('details')}>
            <span
              className={` ${tab === 'details' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'} `}
            >
              Details
            </span>
          </li>
          <li className=" cursor-pointer" onClick={() => setTabs('student')}>
            <span
              className={` ${tab === 'student' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'} `}
            >
              Students
            </span>
          </li>
        </ul>
      </div>

      {tab === 'details' ? (
        <section>
          <div className=" flex justify-between  py-3 items-center">
            <div className="">
              <p className=" text-lg m-0">Cource Details</p>
            </div>
          </div>
          <div className=" p-3 rounded-lg" style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}>
            <span className=" m-0 text-gray-400 text-sm">Cource Name</span>
            <h6 className=" text-lg">{courseData?.name}</h6>

            <span className=" pt-3 m-0 text-gray-400 text-sm">Description</span>
            <h6 className="">{courseData?.description}</h6>
            <ul className=" flex flex-col gap-2 mt-5">
              <li>
                <span className=" m-0 text-gray-400 text-sm">Price</span>
                <p>Rs.{courseData?.price}</p>
              </li>
              <li>
                <span className=" m-0 text-gray-400 text-sm">Lessons</span>
                <p>{courseData?.lesson}</p>
              </li>
              <li>
                <span className=" m-0 text-gray-400 text-sm">Duration</span>
                <p>
                  {courseData?.duration} {courseData?.periodType}
                </p>
              </li>
            </ul>
          </div>
        </section>
      ) : (
        <>
          <section className=" pt-2">
            <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-3 md:grid-cols-2 gap-5">
              <div className=" w-full">
                <div
                  className="  bg-white p-5 rounded-lg flex  justify-between"
                  style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                >
                  <div>
                    <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Total Enrolled</h2>
                    <div className=" pt-2 flex items-center gap-3">
                      <p className="text-lg pt-3  text-[#1C1D1D]">{enrolled}</p>
                    </div>
                  </div>
                  <div>
                    <img src={require('../../assets/image/active.png')} alt="" />
                  </div>
                </div>
              </div>
              {/* <div className=" w-full">
                <div
                  className=" bg-white  flex justify-between p-5 rounded-lg"
                  style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                >
                  <div>
                    <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                    <div className=" pt-2 flex items-center gap-3">
                      <p className="text-lg pt-3 text-black">50</p>
                    </div>
                  </div>
                  <div>
                    <img src={require('../../assets/image/ongoing.png')} alt="" />
                  </div>
                </div>
              </div> */}
            </div>
          </section>

          <section className="mb-20 mt-7">
            <div className="rounded-lg overflow-x-auto">
              <div className="flex flex-col">
                <div className="sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                      <table className="min-w-full mb-0">
                        <thead className="">
                          <tr className="rounded-lg whitespace-nowrap">
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              
                              Sr No.
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              
                              ID
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Name
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Father Name
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Age
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Address
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Country
                            </th>
                            <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                              Timing
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {totalStudents?.map((student, index) => (
                            <tr
                              key={student?.enrollmentDetails?._id}
                              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                              className="bg-white border-b-8 border-white rounded-md"
                            >
                              {/* Row Number */}
                              <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {index + 1}
                                </span>
                              </td>
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {student?.enrollmentDetails?.userDetails?.studentId}
                                </span>
                              </td>

                              {/* Student Name */}
                              <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                  {student?.studentName}
                                </span>
                              </td>

                              {/* Father Name */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.enrollmentDetails?.fatherName}
                                </span>
                              </td>

                              {/* Age */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.age}
                                </span>
                              </td>

                              {/* Address */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.address}
                                </span>
                              </td>

                              {/* Country */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.country}
                                </span>
                              </td>

                              {/* Timing */}
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                  {student?.assignments?.map((item, index) =>
                                    item?.timeSlots?.map((item, index) => {
                                      return (
                                        <span
                                          key={index}
                                          className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full"
                                        >
                                          {item?.startTime} - {item?.endTime}
                                        </span>
                                      );
                                    })
                                  )}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </DoctorWrapper>
  );
};

export default DoctorCourcesDetails;
